class Modals {
	constructor() {
		this.closeModalEvent = new Event('closemodal', {
			bubbles: false,
			cancelable: true,
		})
        this.openModalEvent = new Event('openmodal', {
            bubbles: false,
            cancelable: true,
        })
		this.addListenersOpen();
		this.addListenersClose();
		this.addListenerHash();
	}

	init() {
		const modal = document.querySelector(`[data-modal="${window.location.hash}"]`);

		if (window.location.hash && modal) {
			modal.classList.add('active');
			this._hideScroll();
		} else {
			document.querySelectorAll(`[data-modal]`).forEach(modal => {
				modal.classList.remove('active');
			});
		}
	}

    reInitOpenByHash(hash) {
        document.querySelectorAll('a[data-modal-open][href="#' + hash + '"]').forEach(trigger => {
            trigger.addEventListener('click', this.openModal.bind(this));
        });
    }

	addListenersOpen() {
		document.querySelectorAll('a[data-modal-open]').forEach(trigger => {
			trigger.addEventListener('click', this.openModal.bind(this));
		});
	}

	addListenersClose = () => {
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-modal-close]');

            if (!trigger) return;

            e.preventDefault();

            this.closeModal(e);
        })
	}

	addListenerHash() {
		window.addEventListener('hashchange', this.init.bind(this));
	}

	async openModal(event, hash, callback) {
		let trigger;
		let modal;

		if (!hash) {
			event.preventDefault();

			trigger = event.target.closest('[data-modal-open]');
			modal = document.querySelector(`[data-modal="${trigger.hash}"]`);
			hash = trigger.hash;
		} else {
			trigger = {
				hash,
			};
			modal = document.querySelector(`[data-modal="${hash}"]`);
		}

		if (modal) {
			callback && callback(modal);

			modal.classList.add('active');

			this._hideScroll();
			modal.dispatchEvent(this.openModalEvent);
		} else {
			await this._ajaxLoadModal(hash, modal, callback).then(function (modal) {
			}, function (error) {
				console.error(error);
			});

		}

		window.location.hash = trigger.hash;
		sessionStorage.setItem("last-url", event?.oldURL);
	}

	closeModal(event, hash, callback) {
		let modal;

        if (arguments.length) {
            if (!hash) {
                event.preventDefault();
                modal = event.target.closest('[data-modal]');
            } else {
                modal = document.querySelector(`[data-modal="${hash}"]`);
            }
        } else {
            modal = document.querySelector(`[data-modal="${window.location.hash}"]`)
        }

		if (modal) {
			modal.classList.remove('active');

			if (!document.querySelector('[data-modal].active')) {
                this._visibleScroll();
            }

			const lastUrl = sessionStorage.getItem("last-url");

			if(!!lastUrl){
				if (lastUrl.indexOf('#') === -1) {
					history.pushState("", document.title, window.location.pathname + window.location.search);
				} else {
					window.location.hash = lastUrl.slice(lastUrl.indexOf('#'));
				}
			}

			modal.dispatchEvent(this.closeModalEvent);
			callback?.(modal);
		}
	}

	_hideScroll() {
		const scrollWidth = window.innerWidth - document.body.offsetWidth;

		if (scrollWidth) {
			document.querySelectorAll('[data-modal-fixed]').forEach(element => {
				element.style.paddingRight = `${scrollWidth}px`;
			});
		}

		bodyFixPosition();
	}

	_visibleScroll() {
		document.querySelectorAll('[data-modal-fixed]').forEach(element => {
			element.style.paddingRight = '';
		});

		bodyUnfixPosition();
	}

	_ajaxLoadModal(hash, modal, callback) {
		let self = this;
		return new Promise(function (resolve, reject) {
			BX.ajax.runComponentAction('ibrush:modal', 'loadComponent', {
				mode: 'class',
				data: {fields: {hash: hash, lang: window.lang}}
			}).then(function (response) {

				if (response.data.html == '') {
					reject('The modal window by id ' + hash + ' not found!');
					return;
				}

				let htmlDoc = new DOMParser().parseFromString(response.data.html, 'text/html');
				let kids = [...htmlDoc.body.children];
				for (var i = 0; i < kids.length; i++) {
					let item = kids[i];
					if (item.tagName == "SCRIPT") {
						if (item.hasAttribute('src')) {
							let scriptEl = document.createElement("script");
							self.cloneAttributes(scriptEl, item);
							document.body.appendChild(scriptEl);
						} else {
							eval(item.innerText);
						}
					} else {
						document.body.appendChild(item);
					}
				}

				modal = document.querySelector(`[data-modal="${hash}"]`);

				setTimeout(function () {
					callback && callback(modal);

					modal.classList.add('active');

					self._hideScroll();
					modal.dispatchEvent(self.openModalEvent);

					if (typeof initScripts == 'function') {
						initScripts();
					}

					resolve(modal);
				}, 1);
			}, function (response) {
				reject(response.errors[0]);
			});
		});
	}
};
